// src/components/staff/StaffForm.jsx
import React, { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import {
  TextField,
  Alert,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { format } from 'date-fns';
import { FormSection } from '../../../components/common/form';

const StaffForm = memo(function StaffForm({
  formData,
  onInputChange,
  validationErrors = {},
  loading = false,
  mode = 'create', // 'create' or 'edit'
}) {
  const { t } = useTranslation(['staff', 'common']);

  const handleNameChange = useCallback((event) => {
    onInputChange('name', event.target.value);
  }, [onInputChange]);

  const handleHireDateChange = useCallback((value) => {
    // value is a Date object or null from AdapterDateFns DatePicker
    onInputChange('hire_date', value ? format(value, 'yyyy-MM-dd') : null);
  }, [onInputChange]);

  return (
    <FormSection
      title={mode === 'create'
        ? t('staff:form.staff_member_information')
        : t('staff:form.edit_staff_member_information')
      }
    >
      <TextField
        fullWidth
        label={t('staff:labels.staff_member_name')}
        value={formData.name || ''}
        onChange={handleNameChange}
        error={!!validationErrors.name}
        helperText={validationErrors.name || t('staff:form.name_helper')}
        required
        disabled={loading}
        placeholder={t('staff:placeholders.name')}
        inputProps={{ maxLength: 255 }}
      />
      <DatePicker
        label={t('staff:labels.hire_date')}
        value={formData.hire_date ? new Date(formData.hire_date) : null}
        onChange={handleHireDateChange}
        disabled={loading}
        slotProps={{
          textField: {
            fullWidth: true,
            helperText: t('staff:form.hire_date_helper'),
          },
        }}
      />
      {mode === 'edit' && (
        <Alert severity="info">
          {t('staff:form.password_change_info')}
        </Alert>
      )}
    </FormSection>
  );
});

export default StaffForm;
